import { useCallback, useEffect, useRef, useState } from "react";
import type {
  CheckBoxEventValue,
  InterstateOnChangeEvent
} from "@dealer-center/core-components";
import { CheckBox, Typography } from "@dealer-center/core-components";
import "./ConfigurationPanel.scss";
import { Locale } from "@dealer-center/ddc-core-utils";
import type { AccountConfigurationPayload } from "@dealer-center/ddc-pages-incentives-manager-lambda";

interface ConfigurationPanelProps {
  configuration?: AccountConfigurationPayload;
  onConfigurationChange?: (configuration: AccountConfigurationPayload) => void;
}

export const ConfigurationPanel = ({
  configuration,
  onConfigurationChange
}: ConfigurationPanelProps) => {
  const [isComplianceCheckEnabled, setComplianceCheckEnabled] =
    useState<boolean>(
      configuration ? configuration.complianceCheckEnabled : false
    );
  const [isUseSuppliedImage, setUseSuppliedImage] = useState<boolean>(
    configuration ? configuration.useSuppliedImage : false
  );

  const onConfigurationChangeRef = useRef(onConfigurationChange);
  const configurationRef = useRef(configuration);

  // Update refs when props change
  useEffect(() => {
    onConfigurationChangeRef.current = onConfigurationChange;
    configurationRef.current = configuration;
  });

  useEffect(() => {
    const currentConfiguration = configurationRef.current;
    const currentOnConfigurationChange = onConfigurationChangeRef.current;

    if (currentConfiguration && currentOnConfigurationChange) {
      currentOnConfigurationChange({
        ...currentConfiguration,
        complianceCheckEnabled: isComplianceCheckEnabled,
        useSuppliedImage: isUseSuppliedImage
      });
    }
  }, [isComplianceCheckEnabled, isUseSuppliedImage]);

  return (
    <div className="configuration-panel-frame">
      <div className="configuration-content">
        <Typography variant="h4">
          {Locale.getText("COMPLIANCE_REVIEW")}
        </Typography>
        <div>
          <CheckBox
            aria-label={Locale.getText("ENABLE_COMPLIANCE_REVIEW") as string}
            defaultChecked={isComplianceCheckEnabled}
            label={Locale.getText("ENABLE_COMPLIANCE_REVIEW") as string}
            name="enable-compliance-check"
            value={"enable-compliance-check"}
            onChange={useCallback(
              (event: InterstateOnChangeEvent<CheckBoxEventValue>) => {
                setComplianceCheckEnabled(event.target?.value?.checked);
              },
              []
            )}
          />
        </div>
      </div>
      <div className="configuration-content">
        <Typography variant="h4">{Locale.getText("USE_IMAGE_FEED")}</Typography>
        <div>
          <CheckBox
            checked={isUseSuppliedImage}
            label={Locale.getText("USE_PROVIDER_IMAGE") as string}
            value={"use-supplied-image"}
            onChange={useCallback(
              (event: InterstateOnChangeEvent<CheckBoxEventValue>) => {
                setUseSuppliedImage(event.target?.value?.checked);
              },
              []
            )}
          />
        </div>
      </div>
    </div>
  );
};
